// extracted by mini-css-extract-plugin
export var legendIndicator = "_el-1";
export var legendRight = "_el-0";